import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyASbOLPR1w1lwh8iMrvHK_LdtZ_fKS4FBw",
  authDomain: "amw-online.firebaseapp.com",
  projectId: "amw-online",
  storageBucket: "amw-online.appspot.com",
  messagingSenderId: "477079449148",
  appId: "1:477079449148:web:71f2f536a87f5ed0f0dd39",
  measurementId: "G-JMWCP6V8QL"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Export the initialized services
export { auth, db, storage };